import { Avatar, Space, Tag, Typography } from 'antd'

const { Text } = Typography

interface LitePlan {
  name: string
  avatar?: string | null
}

interface Props {
  plan: LitePlan | null
}

/**
 * Lightweight plan tag renderer for membership analytics read-model rows
 * (ticket 537, API #298) whose `plan` is a lite, denormalized shape - not the
 * full `Plan` model, so `Plan.Tag` (which needs the full model/store lookup)
 * doesn't apply here. `avatar` is optional: some rows (e.g. incoming
 * renewals) don't embed one.
 */
const LitePlanTag = ({ plan }: Props) => {
  if (!plan) {
    return <Text type="secondary">--</Text>
  }

  return (
    <Tag>
      <Space size={4}>
        {plan.avatar && <Avatar src={plan.avatar} size="small" />}
        {plan.name}
      </Space>
    </Tag>
  )
}

export { LitePlanTag }
